var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1444_2170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37156 1.86508L2.15906 1.18258C3.06656 0.275078 4.53657 0.275078 5.44407 1.18258C5.46657 1.20508 6.85407 3.01258 6.85407 3.01258C7.70907 3.91258 7.70907 5.33008 6.85407 6.22258L5.98407 7.31758C7.07907 9.80008 8.78157 11.5101 11.1816 12.5301L12.2766 11.6526C13.1691 10.7901 14.5941 10.7901 15.4866 11.6526C15.4866 11.6526 17.2941 13.0401 17.3166 13.0626C18.2241 13.9701 18.2241 15.4401 17.3541 16.3101L16.6041 17.1726C15.7416 18.0351 14.5791 18.5076 13.3191 18.5076C7.58907 18.5076 -0.000934601 10.9101 -0.000934601 5.18758C-0.000934601 3.93508 0.471565 2.76508 1.37156 1.87258V1.86508ZM13.3191 17.0001C14.1741 17.0001 14.9616 16.6851 15.5016 16.1376L16.2516 15.2751C16.5591 14.9676 16.5741 14.4651 16.2816 14.1426C16.2816 14.1426 14.4891 12.7626 14.4666 12.7401C14.1591 12.4326 13.6191 12.4326 13.3041 12.7401C13.2816 12.7626 11.7741 13.9701 11.7741 13.9701C11.5641 14.1351 11.2866 14.1801 11.0391 14.0826C7.93407 12.8976 5.70656 10.6776 4.42406 7.47508C4.32656 7.22758 4.36407 6.94258 4.53656 6.72508C4.53656 6.72508 5.74407 5.21008 5.75907 5.19508C6.08157 4.87258 6.08157 4.35508 5.75907 4.03258C5.73657 4.01008 4.35656 2.21758 4.35656 2.21758C4.03407 1.92508 3.53157 1.93258 3.18657 2.27758L2.39907 2.96008C1.82157 3.53758 1.49907 4.32508 1.49907 5.18008C1.49907 10.4001 8.82657 17.0001 13.3191 17.0001Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1444_2170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFlip);
export default __webpack_public_path__ + "static/media/phoneFlip.dcb369b1dcc60d7ac8b4a30107e9ed97.svg";
export { ForwardRef as ReactComponent };